<template>
  <v-row>
    <v-col cols="12" v-if="$store.state.suppliers.retrieveLoader">
      <v-boilerplate type="table-heading, divider, list-item-two-line" />
      <v-skeleton-loader class="mt-5" transition="fade-transition" type="table" />
    </v-col>
    <v-col cols="12" v-else>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <v-row align="center" justify="start" no-gutters>
              <router-link :to="{ name: 'BillersBuiltInSettings' }" class="subtitle-1 routerLink font-weight-medium">Facturación incorporada</router-link>
              <v-icon class="mx-1 pt-1" color="secondary">mdi-chevron-right</v-icon>
              <router-link class="subtitle-1 routerLink font-weight-medium" :to="{name: 'SupplierListCreate'}">Proveedores</router-link>
              <v-icon class="mx-1 pt-1" color="secondary">mdi-chevron-right</v-icon>
              <span class="subtitle-1 font-weight-medium d-inline-block text-truncate" :style="$vuetify.breakpoint.width < 1200 ? 'max-width: 300px;' : 'max-width: 500px;'">{{instance.name}}</span>
            </v-row>
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn @click="dialogSupplier=true" outlined retain-focus-on-click>Editar</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <v-row>
            <v-col cols="6">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title class="text--secondary subtitle-1 font-weight-medium">Información general</v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Nombre</v-list-item-title>
                  <v-list-item-subtitle>{{instance.name}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Dirección</v-list-item-title>
                  <v-list-item-subtitle>{{instance.address}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Estado</v-list-item-title>
                  <v-list-item-subtitle>{{instance.state.name}}, {{instance.country.name}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Teléfono</v-list-item-title>
                  <v-list-item-subtitle v-if="instance.phone">{{instance.address}}</v-list-item-subtitle>
                  <v-list-item-subtitle class="font-italic text--disabled" v-else>Sin número de teléfono</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>ID</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-tooltip right transition="scale-transition">
                      <template v-slot:activator="{on}">
                        <v-btn class="font-weight-regular" @click="toClipboard(instance.id)" text color="secondary" v-on="on" :ripple="false">{{instance.id}}</v-btn>
                      </template>
                      <span>Copiar</span>
                    </v-tooltip>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Creado el</v-list-item-title>
                  <v-list-item-subtitle>{{instance.created | date}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Actualizado el</v-list-item-title>
                  <v-list-item-subtitle>{{instance.updated | dateTime}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="6">
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-title class="text--secondary subtitle-1 font-weight-medium">Información de facturación</v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Email de facturación</v-list-item-title>
                  <v-list-item-subtitle>{{instance.email}}</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>ID Fiscal</v-list-item-title>
                  <v-list-item-subtitle v-if="instance.tax_id">{{instance.tax_id}}</v-list-item-subtitle>
                  <v-list-item-subtitle class="font-italic text--disabled" v-else>No especificado</v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Moneda</v-list-item-title>
                  <v-list-item-subtitle>{{activeCurrency.id}} - {{activeCurrency.name}}</v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- purchases list -->
      <v-card class="px-0 mt-5">
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Purchases</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0">
          <purchase-list :show-pagination="false" :show-sort="false" :show-criteria="{supplier: instance.id}" />
        </v-card-text>
      </v-card>
      <!-- end purchases list -->
    </v-col>

    <!-- dialog update supplier-->
    <v-dialog v-if="editable.id" v-model="dialogSupplier" width="700" persistent no-click-animation scrollable>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Editar proveedor</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-1">
                <v-btn class="ml-3" @click="dialogSupplier=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-list class="v-list-form py-6 transparent">
            <v-list-item class="py-1">
              <v-list-item-title>Nombre</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="8">
                  <v-text-field v-model.trim="$v.editable.name.$model" :error="$v.editable.name.$error" background-color="white" outlined required single-line dense placeholder="Acme LLC" maxlength="100" hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title>País</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="8">
                  <v-select v-model="editable.country.name" disabled single-line :items="[editable.country.name]" item-text="name" item-value="id" hide-details dense height="30" outlined background-color="white" />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title>Estado</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="8">
                  <v-select v-model="$v.editable.state.$model" :error="$v.editable.state.$error" :items="statesList" item-text="name" item-value="id" single-line hide-details dense height="30" outlined background-color="white" no-data-text="No existen estados para el país." />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title>Dirección</v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field v-model.trim="$v.editable.address.$model" :error="$v.editable.address.$error" background-color="white" outlined required single-line dense maxlength="64" hide-details/>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="mt-4">
              <v-list-item-title>
                <span class="text--secondary font-weight-medium">Información fiscal</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item class="mt-2">
              <v-list-item-title>
                ID Fiscal
                <v-tooltip right max-width="280px" transition="scale-transition">
                  <template v-slot:activator="{on}">
                    <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                  </template>
                  <span>También llamado RUT, VAT o Tax ID</span>
                </v-tooltip>
              </v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-col cols="8">
                  <v-text-field v-model.trim="editable.tax_id" :disabled="instance.country.has_regulation" background-color="white" outlined single-line dense hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item v-if="editable.country.id === 'CL'">
              <v-list-item-title>Actividad</v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-text-field v-model.trim="$v.editable.tax_settings.cl_activity_description.$model" :error="$v.editable.tax_settings.cl_activity_description.$error" background-color="white" outlined required single-line dense maxlength="64" hide-details />
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="mt-4">
              <v-list-item-title>
                <span class="text--secondary font-weight-medium">Información de contacto</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item class="mt-2">
              <v-list-item-title>Email de facturación</v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-col cols="8">
                  <v-text-field v-model.trim="$v.editable.email.$model" :error="$v.editable.email.$error" outlined required single-line background-color="white" dense maxlength="64" hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Teléfono</v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-col cols="8">
                  <v-text-field v-model.trim="$v.editable.phone.$model" :error="$v.editable.phone.$error" background-color="white" outlined required single-line dense v-if="editable.country" v-mask="`${editable.country.phone_code} # #### ####`" maxlength="16" hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>Sitio web</v-list-item-title>
              <v-list-item-subtitle class="py-1">
                <v-col cols="8">
                  <v-text-field v-model.trim="$v.editable.website.$model" :error="$v.editable.website.$error" background-color="white" outlined required single-line class="pa-0" dense  maxlength="64" :hide-details="true" />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn outlined @click="dialogSupplier=false">Cancelar</v-btn>
          <v-btn @click="updateSupplier" :loading="$store.state.suppliers.createLoader" color="primary">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- dialog update supplier -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, requiredIf, email, url, maxLength } from 'vuelidate/lib/validators'
import PurchaseList from '@/components/purchase/PurchaseList'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import cloneDeep from 'lodash/cloneDeep'
export default {
  mixins: [
    GenericViewMixin
  ],
  inject: ['theme'],
  components: {
    PurchaseList,
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props
          }
        }, children)
      }
    }
  },
  data: () => ({
    activeCurrency: {},
    editable: {},
    dialogSupplier: false,
    taxSettings: [
      {
        country: 'CL',
        fields: ['cl_activity_description']
      }
    ]
  }),
  computed: mapState({
    statesList: state => state.generals.statesList,
    instance: state => state.suppliers.suppliersDetail
  }),
  created () {
    this.$store.dispatch('suppliers/RETRIEVE', {
      resource: 'suppliers',
      id: this.$route.params.id
    })
    .then(() => {
      const supplier = cloneDeep(this.instance)
      const taxSettings = this.taxSettings.find(field => field.country === supplier.country.id)
      if (taxSettings) {
        taxSettings.fields.forEach(field => {
          if (!supplier.tax_settings[field]) {
            supplier.tax_settings[field] = null
          }
        })
      }
      this.editable = supplier
      this.$store.dispatch('generals/LIST', {
        resource: 'generals/states',
        query: {
          country: this.instance.country.id,
          page_size: 500
        }
      })
    })
    .then(() => {
      this.activeCurrency = this.currencies.find(c => c.id === this.instance.currency)
    })
    this.$store.dispatch('purchases/LIST', {
      resource: 'purchases',
      query: {
        supplier: this.$route.params.id,
        page_size: 5
      }
    })
  },
  methods: {
    updateSupplier () {
      this.$v.editable.$touch()
      if (this.$v.editable.$invalid) {
        return false
      }
      const payload = {
        name: this.editable.name,
        state: this.editable.state.id || this.editable.state,
        address: this.editable.address,
        tax_settings: this.editable.tax_settings,
        email: this.editable.email,
        phone: this.editable.phone,
        website: this.editable.website
      }
      if (!this.instance.country.has_regulation) {
        payload.tax_id = this.editable.tax_id
      }
      this.$store.dispatch('suppliers/UPDATE', {
        resource: 'suppliers',
        id: this.$route.params.id,
        payload: payload
      })
      .then(() => {
        this.dialogSupplier = false
        this.$dialog.message.info('El proveedor ha sido actualizado')
      })
      .catch(() => {
        this.$dialog.message.error('Error al actualizar el proveedor.')
      })
    }
  },
  validations: {
    editable: {
      name: {
        required,
        maxLength: maxLength(100)
      },
      state: {
        required
      },
      address: {
        required,
        maxLength: maxLength(64)
      },
      tax_settings: {
        cl_activity_description: {
          required: requiredIf(function () {
            return this.editable.country.id === 'CL'
          }),
          maxLength: maxLength(64)
        }
      },
      tax_id: {
        maxLength: maxLength(32)
      },
      email: {
        required,
        email,
        maxLength: maxLength(254)
      },
      phone: {
        maxLength: maxLength(16)
      },
      website: {
        url
      }
    }
  }
}
</script>